<template>
  <div>
    <span class="label" v-if="inTemplate">
      {{ isActive ? "Inactivar plantilla" : "Activar plantilla" }}
    </span>

    <a-tooltip placement="bottom" :title="isActive ? 'Inactivar' : 'Activar'">
      <a-switch
        name="chatbot-switch"
        :checked="isActive"
        :loading="loadingSwitch"
        :disabled="disabled"
        @change="handleChangeStatus"
        size="small"
      />
    </a-tooltip>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, createVNode } from "vue";
import { Modal, message } from "ant-design-vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";

import { ResponseError } from "@/app/shared/utils/httpManager";
import { Template, TemplateState } from "@/@types/flows/emailTemplates";
import { emailTemplateService } from "@/app/flows/emailTemplates/services/EmailTemplate.service";

const props = defineProps<{
  template: Template;
  inTemplate?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "update"): void;
}>();

const loadingSwitch = ref(false);
const isActive = computed(() => props.template.status === TemplateState.Active);

const handleUpdate = () => emit("update");

const handleChangeStatus = async () => {
  loadingSwitch.value = true;

  try {
    if (isActive.value) {
      await new Promise((res) => {
        Modal.confirm({
          centered: true,
          icon: createVNode(QuestionCircleOutlined),
          title: `¿Estás seguro de inactivar “${props.template.name}”?`,
          content: "Recuerda que puedes volver a activar esta plantilla cuando desees.",
          okText: "Inactivar",
          onOk: async () => {
            await emailTemplateService.toggleState(props.template);
            res(undefined);
          },
        });
      });
    } else {
      await emailTemplateService.toggleState(props.template);
    }

    handleUpdate();
  } catch (error) {
    let errorMessage = "Ha ocurrido un error";

    if (error instanceof ResponseError) errorMessage = error.getErrorMessage();

    message.error(errorMessage);
    console.error(error);
  }

  loadingSwitch.value = false;
};
</script>

<style lang="sass" scoped>
.label
  margin-right: 5px
  font-size: 12px
  color: $gray-8

// .floating
//   position: absolute
//   right: 0
//   top: 0
//   bottom: 0
//   margin: auto 0
//   display: flex
//   align-items: center
//   margin-right: 12px
</style>
